import React from "react";
import { providerLogoSrc } from "../helpers/providerLogo";
import { Avatar, Grid, Paper } from "@mantine/core";
import { IconBuildingSkyscraper } from "@tabler/icons";
import InfoGridList from "./infoGridList";

const emptyStr = "-";

const ProviderInfoSummary = ({ provider }) => {
  if (!provider) return null;

  const leftFields = [
    { title: "Internal Code", value: provider.code || emptyStr },
    { title: "English Name", value: provider.name || emptyStr },
    { title: "Chinese Name", value: provider.cname || emptyStr },
  ];

  const rightFields = [
    { title: "Broker Code", value: provider.insurerCode || emptyStr },
    { title: "Primary Tel", value: provider.tel || emptyStr },
    { title: "Email", value: provider.email || emptyStr },
  ];

  return (
    <Paper shadow="md" p="xl" radius={0} mb="md">
      <Grid columns={24} align="flex-start" gutter="xl">
        <Grid.Col span={4}>
          <Avatar
            src={providerLogoSrc(provider) || null}
            radius="md"
            size={110}
          >
            <IconBuildingSkyscraper size="2.25rem" />
          </Avatar>
        </Grid.Col>
        <Grid.Col span={9}>
          <InfoGridList fields={leftFields} values={provider} cols={1} />
        </Grid.Col>
        <Grid.Col span={11}>
          <InfoGridList fields={rightFields} values={provider} cols={1} />
        </Grid.Col>
      </Grid>
    </Paper>
  );
};

export default ProviderInfoSummary;
